import { Component } from '@angular/core';
import { Subscription } from 'rxjs';
import { SessionService } from './shared/services/session.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'sso-apps-portal-ui';
  authStatus = false;
  authSubcription$: Subscription = new Subscription();
  constructor(private sessionService: SessionService, private router: Router) { }

    ngOnInit(): void {
      this.cleanupMsalCookies();
      this.authSubcription$ = this.sessionService.authStatus.subscribe(() => {
        this.setAuthStatus();
      });
    }

    /** Remove legacy MSAL cookies to prevent RequestHeaderSectionTooLarge (8KB limit). Tokens are now in sessionStorage. */
    private cleanupMsalCookies(): void {
      try {
        const cookies = document.cookie.split(';');
        const hostname = window.location.hostname;
        cookies.forEach((cookie) => {
          const name = cookie.split('=')[0].trim();
          if (name && name.toLowerCase().includes('msal')) {
            document.cookie = `${name}=; Max-Age=0; path=/`;
            document.cookie = `${name}=; Max-Age=0; path=/; domain=${hostname}`;
            if (hostname.indexOf('.') > 0) {
              document.cookie = `${name}=; Max-Age=0; path=/; domain=.${hostname}`;
            }
          }
        });
      } catch {
        // ignore
      }
    }

    setAuthStatus(): void {
      this.authStatus = this.sessionService.isLoggedIn();
    }
    getAuthStatus() {
      return this.sessionService.isLoggedIn();
    }
    ngOnDestroy(): void {
      this.authSubcription$?.unsubscribe();
    }
}
